import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getAulasByModulo, showAula, getMateriaisAula } from '../../../api/aula';
import { createAlunoAula, createAlunoAulaLike, createAlunoAulaArquivo, checkAula } from '../../../api/aluno';
import { useNavigate } from 'react-router-dom';
import { retrieveToken } from './../../../hooks/use-token';

const AulaAssistirArea = ({ idModulo, idAula }) => {
  
  const [isCheck, setCheck] = useState(false);
  const [aulas, setAulas] = useState([]);
  const [materiais, setMateriais] = useState(null);
  const [aula, setAula] = useState(null);
  const [aulaLike, setAulaLike] = useState(false);
  const [aulaAluno, setAulaAluno] = useState(false);
  const [aulaAlunoArquivo, setAulaAlunoArquivo] = useState(false);
  
  const navigate = useNavigate();
  
  useEffect(() => {
    console.log('materiais', materiais);
  }, [materiais])

  useEffect(() => {
    
    const tokenApi = retrieveToken();
    
    if (!tokenApi) {
      navigate("/entrar");
    } else {
      
      showAula(tokenApi, Number(idAula)).then(function(result) {
        setAula(result);
        
        checkAula(tokenApi, {
          "aula_fk": idAula
        }).then(function(result) {
          if (result.data) {
            if (result.data.arquivo === true) {
              setAulaAlunoArquivo(true);
            } else {
              setAulaAlunoArquivo(false);
            }
            if (result.data.like === true) {
              setAulaLike(true);
            } else {
              setAulaLike(false);
            }
            if (result.data.assistido === true) {
              setAulaAluno(true);
            } else {
              setAulaAluno(false);
            }
          }
        });
        
      });
      
      if (idModulo !== null && idAula !== null && !isCheck)  {
        
        getAulasByModulo(tokenApi, Number(idModulo)).then(function(result) {
          setAulas(result);
        });
        
        setCheck(true);
        
      }
      
      if (idAula !== null) {
        
        getMateriaisAula(tokenApi, Number(idAula)).then(function(result) {
          setMateriais(result);
        });
        
      }
    }
    
  }, [idAula, navigate]);
  
  function renderVideo(iframeUrl) {
    return {__html: iframeUrl};
  }
  
  function showVideo(iframeUrl) {
    return <div dangerouslySetInnerHTML={renderVideo(iframeUrl)} />;
  }
  
  function renderListMateriais() {
    console.log('renderListMateriais', materiais)
    return (
      <div className="table-content table-responsive" style={{ marginTop: 35 }}>
        <table className="table">
          <thead>
            <tr>
              <th className="cart-product-name">Nome</th>
              <th className="cart-product-name">Baixar</th>
            </tr>
          </thead>
          <tbody>
            {materiais.map((material, index) => (
              <tr key={index}>
                <td>{material.nome}</td>
                <td>
                  <a
                    className="btn btn-primary"
                    href={`https://v1.profaprizattera.com.br/uploads/download/${material.file}`}
                    target="_blank"
                  >
                    Clique aqui
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
      }
      
      function renderListaAulas() {
        return <>
        <div className="sidebar__widget mb-55">
        <div className="sidebar__widget-head mb-35">
        <h3 className="sidebar__widget-title">Assista também</h3>
        </div>
        <div className="sidebar__widget-content">
        <div className="rc__post-wrapper">
        {aulas.slice(0, 3).map((aula, i) => (
          <div key={i} className="rc__post d-flex align-items-center">
          <div className="rc__thumb mr-20">
          {aula.file != '' && <Link to={`/modulo/${aula.modulo_fk}/aula/assistir/${aula.cd_aula}`}>
          <img src={"https://v1.profaprizattera.com.br/uploads/aula/" +  aula.file} alt="" />
          </Link>}
          </div>
          <div className="rc__content">
          
          <h6 className="rc__title">
          <Link to={`/modulo/${aula.modulo_fk}/aula/assistir/${aula.cd_aula}`}>{aula.titulo}</Link>
          </h6>
          </div>
          </div>
          ))}
          </div>
          </div>
          </div>
          </>;
        }
        
        const handleAulaLike = () => {
          
          const tokenApi = retrieveToken();
          
          createAlunoAulaLike(tokenApi, {
            "aula_fk": idAula,
            "file_app": null
          }).then(function(result) {
            if (aulaLike) {
              setAulaLike(false);
            } else {
              setAulaLike(true);
            }
          });
          
        }
        
        const handleAulaAluno = () => {
          
          const tokenApi = retrieveToken();
          
          createAlunoAula(tokenApi, {
            "aula_fk": idAula,
          }).then(function(result) {
            if (aulaAluno) {
              setAulaAluno(false);
            } else {
              setAulaAluno(true);
            }
          });
          
        }
        
        const handleAulaAlunoArquivo = () => {
          
          const tokenApi = retrieveToken();
          
          createAlunoAulaArquivo(tokenApi, {
            "aula_fk": idAula,
            "path": window.location.pathname
          }).then(function(result) {
            if (aulaAlunoArquivo) {
              setAulaAlunoArquivo(false);
            } else {
              setAulaAlunoArquivo(true);
            }
          });
          
        }
        
        if (idModulo !== null && idAula !== null && aula)  {
          
          return (
            <>
            
            <section className="page__title-area pt-120 pb-90">
            {/* <div className="page__title-shape">
            <img className="page-title-shape-5 d-none d-sm-block" 
            src="/assets/img/page-title/page-title-shape-1.png" alt="" />
            <img className="page-title-shape-6" src="/assets/img/page-title/page-title-shape-6.png" alt="" />
            <img className="page-title-shape-7" src="/assets/img/page-title/page-title-shape-4.png" alt="" />
          </div> */}
          <div className="container">
          <div className="row">
          <div className="col-xxl-8 col-xl-8 col-lg-8">
          <div className="course__wrapper">
          <div className="page__title-content mb-25">
          <div className="page__title-breadcrumb">
          <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
          <li className="breadcrumb-item"><Link to="/">Home</Link></li>
          <li className="breadcrumb-item"><Link to="/cursos">Aula</Link></li>
          <li className="breadcrumb-item active" aria-current="page">{aula.titulo}</li>
          </ol>
          </nav>
          </div>
          {/* <span className="page__title-pre">{course.category}</span> */}
          <h5 className="page__title-3">{aula.titulo}</h5>
          </div>
          <div className="course__img w-img mb-30">
          { showVideo(aula.video) }
          </div>
          <div className="course__tab-2 mb-45">
          <ul className="nav nav-tabs" id="courseTab" role="tablist">
          <li className="nav-item" role="presentation">
          <button className="nav-link" id="description-tab" data-bs-toggle="tab" data-bs-target="#description" type="button" role="tab" aria-controls="description" aria-selected="true"> <i className="icon_ribbon_alt"></i> <span>Descrição</span> </button>
          </li>
          <li className="nav-item" role="presentation">
          <button className={aulaLike ? "nav-link active" : "nav-link"} id="like-tab" onClick={handleAulaLike}> 
          <i className="fa fa-heart" aria-hidden="true"></i>
          <span>Gostei</span> 
          </button>
          </li>
          <li className="nav-item" role="presentation">
          <button className={aulaAluno ? "nav-link active" : "nav-link"} onClick={handleAulaAluno}> 
          <i className="fa fa-eye" aria-hidden="true"></i>
          <span>Assistido</span> 
          </button>
          </li>
          <li className="nav-item" role="presentation">
          <button className={aulaAlunoArquivo ? "nav-link active" : "nav-link"} onClick={handleAulaAlunoArquivo}> 
          <i className="fa fa-archive" aria-hidden="true"></i>
          <span>Assistir mais tarde</span> 
          </button>
          </li>
          {/*
            <li className="nav-item" role="presentation">
            <button className="nav-link" id="review-tab" data-bs-toggle="tab" data-bs-target="#review" type="button" role="tab" aria-controls="review" aria-selected="false"> <i className="icon_star_alt"></i> <span>Reviews</span> </button>
            </li>
            <li className="nav-item" role="presentation">
            <button className="nav-link" id="member-tab" data-bs-toggle="tab" data-bs-target="#member" type="button" role="tab" aria-controls="member" aria-selected="false"> <i className="fal fa-user"></i> <span>Members</span> </button>
          </li> */}
          </ul>
          </div>
          {aula.descricao.length > 1 && <div className="course__tab-content mb-95">
          <div className="tab-content" id="courseTabContent">
          <div className="tab-pane fade show active" id="description" role="tabpanel" aria-labelledby="description-tab">
          <div className="course__description">
          <p>{aula.descricao}</p>
          </div>
          </div>
          {/*
            <div className="tab-pane fade" id="curriculum" role="tabpanel" aria-labelledby="curriculum-tab">
            
            </div>
            <div className="tab-pane fade" id="review" role="tabpanel" aria-labelledby="review-tab">
            
            </div>
            <div className="tab-pane fade" id="member" role="tabpanel" aria-labelledby="member-tab">
            
            </div>
            <div className="course__share">
            <h3>Compartilhe:</h3>
            <ul>
            <li><a href="#" className="fb" ><i className="social_facebook"></i></a></li>
            <li><a href="#" className="tw" ><i className="social_twitter"></i></a></li>
            <li><a href="#" className="pin" ><i className="social_pinterest"></i></a></li>
            </ul>
          </div> */}
          </div>
          </div>}
          
          {materiais !== null && <div className="tab-content" id="courseTabContent">
          <div className="tab-pane fade show active" id="description" role="tabpanel" aria-labelledby="description-tab">
          <div className="course__description">
          <h3>Materiais</h3>
          {renderListMateriais()}
          </div>
          </div>
          </div>}
          
          {/* <div className="course__related">
          <div className="row">
          <div className="col-xxl-12">
          <div className="section__title-wrapper mb-40">
          <h2 className="section__title">Related <span className="yellow-bg yellow-bg-big">Course<img src="/assets/img/shape/yellow-bg.png" alt="" /></span></h2>
          <p>You don't have to struggle alone, you've got our assistance and help.</p>
          </div>
          </div>
          </div>
          <div className="row">
          <div className="col-xxl-12">
          <div className="course__slider swiper-container pb-60">
          {<Swiper modules={[Pagination]} spaceBetween={20}
          slidesPerView={1} className="pb-60" loop={true}
          pagination={{ el: '.swiper-pagination', clickable: true }}
          autoplay={{ delay: 6000 }}
          breakpoints={{
            // when window width is >= 768px
            768: {
              slidesPerView: 2
            },
          }}
          >
          {courses.slice(0, 4).map(item => {
            return (
              <SwiperSlide key={item.id}>
              <div className="course__item course__item-3 swiper-slide white-bg mb-30 fix">
              <div className="course__thumb w-img p-relative fix">
              <Link to={`/curso-detalhes/${item.id}`}>
              <img src={item.courseImage} alt="" />
              </Link>
              <div className="course__tag">
              <a href="#" className={item.color}>{item.category}</a>
              </div>
              </div>
              <div className="course__content">
              <div className="course__meta d-flex align-items-center justify-content-between">
              <div className="course__lesson">
              <span><i className="far fa-book-alt"></i>{item.lesson} Lesson</span>
              </div>
              <div className="course__rating">
              <span><i className="icon_star"></i>{item.rating} ({item.total_rating})</span>
              </div>
              </div>
              <h3 className="course__title">
              <Link to={`/curso-detalhes/${item.id}`}>{item.title}</Link>
              </h3>
              <div className="course__teacher d-flex align-items-center">
              <div className="course__teacher-thumb mr-15">
              <img src={item.teacherImg} alt="" />
              </div>
              <h6><Link to="/instructor-details">{item.teacherName}</Link></h6>
              </div>
              </div>
              <div className="course__more d-flex justify-content-between align-items-center">
              {item.price === 'free' && <div className="course__status">
              <span>Free</span>
              </div>}
              {item.price !== 'free' && <div className="course__status d-flex align-items-center">
              <span className={item.color}>${item.price}</span>
              {item.oldPrice && <span className="old-price">${item.oldPrice}</span>}
              </div>}
              <div className="course__btn">
              <Link to={`/curso-detalhes/${item.id}`} className="link-btn">
              Know Details
              <i className="far fa-arrow-right"></i>
              <i className="far fa-arrow-right"></i>
              </Link>
              </div>
              </div>
              </div>
              </SwiperSlide>
              )
            })
          }
          
          <div className="swiper-pagination"></div>
          </Swiper>}
          </div>
          </div>
          </div>
        </div> */}
        </div>
        </div>
        <div className="col-xxl-4 col-xl-4 col-lg-4">
        <div className="course__sidebar pl-70 p-relative">
        <div className="course__shape">
        <img className="course-dot" src="/assets/img/curso/course-dot.png" alt="" />
        </div>
        {renderListaAulas()}
        {/* <div className="course__sidebar-widget-2 white-bg mb-20">
        
        <RelatedCourse />
        
      </div> */}
      </div>
      </div>
      </div>
      </div>
      </section>
      </>
      );
      
    }
  };
  
  export default AulaAssistirArea;